import { render, staticRenderFns } from "./FAQText.vue?vue&type=template&id=b1a83e08&scoped=true&"
var script = {}
import style0 from "./FAQText.vue?vue&type=style&index=0&id=b1a83e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a83e08",
  null
  
)

export default component.exports